import domContentLoaded from 'dom-content-loaded';
import $ from 'jquery';

export default () => {
  domContentLoaded(() => {
    // フェードイン アニメーション
    const fadeinRight = $('.js_fade');
    const windowHeight = $(window).height() - 100;

    $(window).on('load scroll', function () {
      if ($(this).scrollTop() > windowHeight && fadeinRight.hasClass('is_animated') === false) {
        fadeinRight.addClass('is_animated');
      } else if ($(this).scrollTop() < 100 && fadeinRight.hasClass('is_animated') === true) {
        fadeinRight.removeClass('is_animated');
      }
    });
  });
};
